/**
 * Created by liuxi on 2023/12/21 10:25
 */
import { lazy } from 'react'
import {
  RouteObject,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom'
import { useAuth } from 'stores/auth'

import Redirect from 'components/Layout/Redirect'
import { Layout } from 'components/Layout2'

import LazyComponent from 'components/LazyComponent'
import ErrorPage from './ErrorPage'
import Next from './Next'

const TalentPlanning = lazy(() => import('./StoreOpening/Talent/List'))
const NpDivision = lazy(() => import('./StoreOpening/NpDivision/Page'))
// import GridPlanningList from './StoreOpening/Grid/List'
const ProjectList = lazy(() => import('./StoreOpening/Project/List/List'))
const NearestShop = lazy(() => import('./StoreOpening/NearestShop'))
const ProjectDetail = lazy(() => import('./StoreOpening/Project/Detail/Detail'))
const ProjectPreviewList = lazy(
  () => import('./StoreOpening/ProjectPreview/List/List')
)
const ShopTax = lazy(() => import('./Shareholder/ShopTax'))

const ProjectPreviewDetail = lazy(
  () => import('./StoreOpening/ProjectPreview/Detail/Detail')
)
const ProjectTalentMatch = lazy(
  () => import('./StoreOpening/ProjectTalentMatch/List')
)
const ProjectManagementList = lazy(
  () => import('./StoreOpening/ProjectManagement/Project/List')
)
const ProjectManagementDetail = lazy(
  () => import('./StoreOpening/ProjectManagement/Project/Detail')
)
const PunchRecordList = lazy(
  () => import('./StoreOpening/ProjectManagement/PunchRecord/List')
)
const PartnershipAreaManage = lazy(
  () => import('./StoreOpening/PartnershipArea/Manage')
)
const PartnershipAreaMap = lazy(
  () => import('./StoreOpening/PartnershipArea/Map')
)
const PartnerAdmittance = lazy(() => import('./StoreOpening/PartnerAdmittance'))
const PartnerAdmittanceDetail = lazy(
  () => import('./StoreOpening/PartnerAdmittance/Detail')
)

const SettingAccount = lazy(() => import('./Setting/Account'))
const SettingOrderStore = lazy(() => import('./Setting/OrderStore'))
const SettingOrderStoreV2 = lazy(() => import('./Setting/OrderStoreV2'))
const SettingDeadMessage = lazy(() => import('./Setting/DeadMessage'))
const SettingDeadMessageDetail = lazy(
  () => import('./Setting/DeadMessage/Detail')
)

const ClosingCheck = lazy(() => import('./FinFee/ClosingCheck'))
const FinFeeOrderGroup = lazy(() => import('./FinFee/Engine/OrderGroup'))
const FinFeeTask = lazy(() => import('./FinFee/Engine/Task'))
const FinFeeSealList = lazy(() => import('./FinFee/Engine/SealList'))
const FinFeeLog = lazy(() => import('./FinFee/Engine/Log'))
const FinFeeSource = lazy(() => import('./FinFee/Engine/Source'))

const FinFeeFeeApplyList = lazy(() => import('./FinFee/Budget/FeeApply/List'))
const FinFeeFeeApplyDetail = lazy(
  () => import('./FinFee/Budget/FeeApply/Detail')
)

const FinFeeTpl = lazy(() => import('./FinFee/Engine/Tpl'))
const FinFeeTplDetail = lazy(() => import('./FinFee/Engine/Tpl/Detail'))
const FinFeeReportDetail = lazy(() => import('./FinFee/Report/Detail'))
const FinFeeReport = lazy(() => import('./FinFee/Report/List'))
// 审批人规则列表
const FinFeeApproverRules = lazy(() => import('./FinFee/ApproverRules'))
// 审批人规则表达式列表
const FinFeeApproverRuleExpression = lazy(
  () => import('./FinFee/ApproverRuleExpression')
)
// 会员储值卡对账
const FinFeeMemberCardBeforeTransferList = lazy(
  () => import('./FinFee/MemberCard/BeforeTransferList')
)
const FinFeeMemberCardTransferredList = lazy(
  () => import('./FinFee/MemberCard/TransferredList')
)
// 财务决算
const BudgetCategory = lazy(() => import('./FinFee/Budget/Category'))
const BudgetCategoryAfter = lazy(() => import('./FinFee/Budget/CategoryAfter'))
const BudgetOrder = lazy(() => import('./FinFee/Budget/Order'))
const BudgetSetting = lazy(() => import('./FinFee/Budget/Setting'))
const BudgetPaymentMethodSetting = lazy(
  () => import('./FinFee/Budget/PaymentMethodSetting')
)
const BudgetManualSettlementApply = lazy(
  () => import('./FinFee/Budget/ManualSettlementApply')
)
const BudgetPaymentOrder = lazy(() => import('./FinFee/Budget/PaymentOrder'))
const NewBudgetPaymentOrderDetails = lazy(
  () => import('./FinFee/Budget/NewPayMentOrderDetails')
)
const BudgetInvestSettlementList = lazy(
  () => import('./FinFee/Budget/InvestSettlement/List')
)
const BudgetInvestSettlementDetail = lazy(
  () => import('./FinFee/Budget/InvestSettlement/Detail')
)

const FinFeeShopProfitReport = lazy(
  () => import('./FinFee/Report/ShopProfitReport')
)
const FinFeeVoucher = lazy(() => import('./FinFee/Voucher/List'))
const FinFeeVoucherDetailList = lazy(
  () => import('./FinFee/Voucher/DetailList')
)
const FinFeeVoucherMultiGroupList = lazy(
  () => import('./FinFee/Voucher/MultiGroupList')
)
const FinFeeVoucherMultiDetailList = lazy(
  () => import('./FinFee/Voucher/MultiDetailList')
)
/** start:: 财务管理费用 */
const FinFeeModeMaintenance = lazy(
  () => import('./FinFee/ManagementFee/FinFeeModeMaintenance')
)
const FinFeeReportList = lazy(
  () => import('./FinFee/ManagementFee/FinFeeReportList')
)
const FinFeeModeMaintenanceDetail = lazy(
  () => import('./FinFee/ManagementFee/FinFeeModeMaintenance/Detail')
)
const FinFeeSalesReconSalesDataList = lazy(
  () => import('./FinFee/SalesRecon/SalesData/List')
)
const FinFeeSalesReconRuleSettingList = lazy(
  () => import('./FinFee/SalesRecon/RuleSetting/List')
)
const FinFeeSalesReconRuleSettingDetail = lazy(
  () => import('./FinFee/SalesRecon/RuleSetting/Detail')
)
const FinFeeSalesReconMallSalesDetail = lazy(
  () => import('./FinFee/SalesRecon/MallSalesDetail')
)
const SalesReconDetailsList = lazy(
  () => import('./FinFee/SalesRecon/SalesReconDetails/List')
)
const SalesReconDetailsCashDetail = lazy(
  () => import('./FinFee/SalesRecon/SalesReconDetails/ReconDetails/CashDetail')
)
const SalesReconDetailsOrderDetail = lazy(
  () => import('./FinFee/SalesRecon/SalesReconDetails/ReconDetails/OrderDetail')
)
/* 异常告警 */
const FinFeeWarningList = lazy(() => import('./FinFee/Warning/List'))
/** end:: 财务管理费用 */

const FinInvestProgressList = lazy(() => import('./FinFee/InvestProgress/List'))

const DevManage = lazy(() => import('./StoreOpening/Dev/Manage'))
const DevMap = lazy(() => import('./StoreOpening/Dev/Map'))
const MenuList = lazy(() => import('./Product/Menu/List'))

const CityManage = lazy(() => import('./StoreOpening/CityManage'))
const AmortizationBaseTypeList = lazy(
  () => import('./Amortization/Base/TypeList')
)
const AmortizationManageList = lazy(() => import('./Amortization/Manage/List'))
const AmortizationChangeList = lazy(() => import('./Amortization/Change/List'))
const AmortizationDealList = lazy(() => import('./Amortization/Deal/List'))
const AmortizationStandBookList = lazy(
  () => import('./Amortization/StandBook/List')
)
const AmortizationManageDetail = lazy(
  () => import('./Amortization/Manage/Detail')
)
const CheckList = lazy(() => import('./Amortization/Check'))
const MainReportEC = lazy(() => import('./MainReport/EC/List'))
const MainReportECDetail = lazy(() => import('./MainReport/EC/Detail'))

/** 门店通讯录 */
const StoreContactsList = lazy(() => import('./MainReport/StoreContacts/List'))

/** 流程管理 */
const FlowList = lazy(() => import('./Flow/FlowList'))
const FlowDetail = lazy(() => import('./Flow/FlowDetail'))
const FlowImport = lazy(() => import('./Flow/FlowImport'))
const ServiceTaskList = lazy(() => import('./Flow/ServiceTaskList'))
const ServiceTaskDetail = lazy(() => import('./Flow/ServiceTaskDetail'))
const ApiList = lazy(() => import('./Flow/ApiList'))
const ApiDetail = lazy(() => import('./Flow/ApiDetail'))
// 流程数据管理
const FlowFormList = lazy(() => import('./Flow/FlowFormList'))
const FlowFormListDetails = lazy(() => import('./Flow/FlowFormList/details'))

/** 合同管理 */
const ContractRentList = lazy(() => import('./Contract/Rent/List'))
const ContractRentDetail = lazy(() => import('./Contract/Rent/Detail'))
const ContractProjectList = lazy(() => import('./Contract/Project/List'))
const ContractProjectDetail = lazy(() => import('./Contract/Project/Detail'))
const ContractProjectConfig = lazy(() => import('./Contract/Project/Config'))
/** 总部合同管理 */
const ContractHeadquartersList = lazy(
  () => import('./Contract/Headquarters/List')
)
const ContractHeadquartersDetail = lazy(
  () => import('./Contract/Headquarters/Detail')
)

// 会议+签到
const MeetingList = lazy(() => import('./activity/Meeting/List'))
const MeetingDetail = lazy(() => import('./activity/Meeting/Detail'))

/** 店长投票管理 */
const VotingList = lazy(() => import('./activity/ManagerVoting/VotingList'))
const VotingDetail = lazy(() => import('./activity/ManagerVoting/VotingDetail'))

/** 店长大学堂 */
const ManagerStudyClassList = lazy(
  () => import('./activity/ManagerStudy/ClassList')
)
const ManagerStudyClassDetail = lazy(
  () => import('./activity/ManagerStudy/ClassDetail')
)

/**
 * 股东系统 start
 */
const ShareholderRoll = lazy(() => import('./Shareholder/Roll'))
const ShareholderRollDetail = lazy(() => import('./Shareholder/Roll/Detail'))
const ShareholderRollLog = lazy(() => import('./Shareholder/Roll/Log'))
const ShareholderShare = lazy(() => import('./Shareholder/Share'))
const ShareholderShareDetail = lazy(() => import('./Shareholder/Share/Detail'))
const ShareholderShareLog = lazy(() => import('./Shareholder/Share/Log'))
const ShareholderUser = lazy(() => import('./Shareholder/User'))
const ShareholderPrePare = lazy(() => import('./Shareholder/PrePare'))
const ShareholderRemit = lazy(() => import('./Shareholder/Remit'))
const ShareholderPrePareDetail = lazy(
  () => import('./Shareholder/PrePare/Detail')
)
const ShareholderProfit = lazy(() => import('./Shareholder/Profit'))
const ShareholderProfitLog = lazy(() => import('./Shareholder/Profit/Log'))
const ShareholderProfitDetail = lazy(
  () => import('./Shareholder/Profit/Detail')
)
const ShareholderSubjectBalance = lazy(
  () => import('./Shareholder/SubjectBalance')
)

/** 门店管理 */
const StoreTerminalList = lazy(() => import('./StoreTerminal/Store/List'))
// const StoreTerminalDetail = lazy(() => import('./StoreTerminal/Store/Detail'))
const StoreTerminalDetail2 = lazy(() => import('./StoreTerminal/Store/Detail2'))

/** Spu管理 */
const SpuManageList = lazy(() => import('./Spu/Manage/List'))

/** 主数据日志管理 */
const MasterDataLogList = lazy(() => import('./MasterDataLog/Manage/List'))

/**公司 */
const CompanyBillList = lazy(() => import('./Company/Bill/List'))
const CompanyBillDetail = lazy(() => import('./Company/Bill/Detail'))
const CompanySealList = lazy(() => import('./Company/Seal/List'))
const CompanySealLogList = lazy(() => import('./Company/SealLog/List'))

const FreezeWater = lazy(() => import('./FinFee/Budget/FreezeWater'))
const FreezeShop = lazy(() => import('./FinFee/Budget/FreezeShop'))

const FundBalance = lazy(() => import('./FinFee/Fund/Balance'))
const FundRealTimeBalance = lazy(() => import('./FinFee/Fund/RealTimeBalance'))

const FundAccount = lazy(() => import('./FinFee/Fund/Account'))
const CIticBalance = lazy(() => import('./FinFee/Fund/CIticBalance'))
const DataBalance = lazy(() => import('./FinFee/Fund/DataBalance'))

const BankReconciliations = lazy(
  () => import('./FinFee/Fund/BankReconciliations')
)
const TaskList = lazy(() => import('@micun/web-components/dist/pages/taskList'))
const Apply = lazy(
  () => import('@micun/web-components/dist/supply/OrdersApply')
)
const ApplyDetail = lazy(
  () => import('@micun/web-components/dist/supply/OrdersApplyDetail')
)

const Purchase = lazy(() => import('@micun/web-components/dist/pages/purchase'))
const Receipt = lazy(() => import('@micun/web-components/dist/pages/receipt'))
const ReceiptDetail = lazy(
  () => import('@micun/web-components/dist/pages/receiptDetail')
)
const PurchaseDetail = lazy(
  () => import('@micun/web-components/dist/pages/purchaseDetail')
)
const BasePurchase = lazy(
  () => import('@micun/web-components/dist/supply/BasePurchase')
)
const BaseWarehouse = lazy(
  () => import('@micun/web-components/dist/supply/BaseWarehouse')
)
const BaseMapping = lazy(
  () => import('@micun/web-components/dist/supply/BaseMapping')
)

const BaseProductStatus = lazy(
  () => import('@micun/web-components/dist/supply/BaseProductStatus')
)

const BaseProductMapping = lazy(
  () => import('@micun/web-components/dist/supply/BaseProductMapping')
)

const WarehouseBaseline = lazy(
  () =>
    import('@micun/web-components/dist/supply/LogisticsCost/WarehouseBaseline')
)

const TransportBaseline = lazy(
  () =>
    import('@micun/web-components/dist/supply/LogisticsCost/TransportBaseline')
)

const OrdersForecasting = lazy(
  () => import('@micun/web-components/dist/supply/OrdersForecasting')
)
const OrdersForecastingDetail = lazy(
  () => import('@micun/web-components/dist/supply/OrdersForecastingDetail')
)

const ProductSkuConversionCost = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/CostManage/ProductSkuConversionCost'
    )
)
const WarehousingLogisticsCost = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/CostManage/WarehousingLogisticsCost'
    )
)

const StandardsLibrary = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/productQuality/StandardsLibrary/List'
    )
)
const StandardRuleConfiguration = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/productQuality/StandardRuleConfiguration/List'
    )
)
const ProductQualityCheckOrderList = lazy(
  () =>
    import('@micun/web-components/dist/supply/productQuality/checkOrder/List')
)
const ProductQualityCheckOrderDetail = lazy(
  () =>
    import('@micun/web-components/dist/supply/productQuality/checkOrder/Detail')
)

const SupplyCapacity = lazy(
  () => import('@micun/web-components/dist/supply/SupplyCapacity')
)
const SupplyCapacityDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplyCapacityDetail')
)
const SupplyCapacityManagementEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/CapacityManagementTab/Edit'
    )
)
const SupplySchedulingManagementEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/SchedulingManagementTab/Edit'
    )
)
const SupplyInventoryStatisticsEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/InventoryStatisticsTab/Edit'
    )
)

const SupplyOrder = lazy(
  () => import('@micun/web-components/dist/supply/SupplyOrder')
)

const SupplyOrderDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplyOrderDetail')
)

const SupplyOrderAdd = lazy(
  () => import('@micun/web-components/dist/supply/SupplyOrderAdd')
)

const SupplySend = lazy(
  () => import('@micun/web-components/dist/supply/SupplySend')
)

const SupplySendDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplySendDetail')
)

const ProductLabelPrintList = lazy(
  () => import('@micun/web-components/dist/supply/ProductLabelPrint/List')
)

const PersonnelManagement = lazy(() => import('./personnelManagement/List'))
const PersonnelManagementDetail = lazy(
  () => import('./personnelManagement/Detail')
)

/** 验收设置 */
const Template = lazy(
  () => import('./StoreOpening/BaseSettings/Acceptance/AcceptanceTemplate')
)
const TemplateConfig = lazy(
  () => import('./StoreOpening/BaseSettings/Acceptance/TemplateConfig')
)

/** 开工令模板 */
const WorkStartOrderTemplateList = lazy(
  () => import('./StoreOpening/WorkStartOrderTemplate/List')
)
const WorkStartOrderTemplateDetail = lazy(
  () => import('./StoreOpening/WorkStartOrderTemplate/Detail')
)

/** 开店流程-基础设置-营业额模板 */
const RevenueTemplateList = lazy(
  () => import('./StoreOpening/BaseSettings/RevenueTemplate/List')
)
const RevenueTemplateDetail = lazy(
  () => import('./StoreOpening/BaseSettings/RevenueTemplate/Detail')
)

const StoreManage = lazy(() => import('./TaskManage/Store'))
const StoreTaskPlanList = lazy(() => import('./TaskManage/Plan/List'))
const StoreTemplateList = lazy(() => import('./TaskManage/TemplateList'))
const StoreTemplateConfig = lazy(
  () => import('./TaskManage/TemplateList/TemplateConfig')
)
const StoreTools = lazy(() => import('./StoreOperation/StoreTools'))
const SmsNotifyList = lazy(() => import('./StoreOpening/SmsNotify/List'))

const ShopSalaryList = lazy(() => import('./PeopleManage/ShopSalary/List'))
const ShopSalaryFieldConfig = lazy(
  () => import('./PeopleManage/ShopSalary/FieldConfig')
)

const ProdManageSpuList = lazy(() => import('./Product/Manage/SpuDocs/List'))
const ProdManageSpuDetail = lazy(
  () => import('./Product/Manage/SpuDocs/Detail')
)
const ProdManageSkuList = lazy(() => import('./Product/Manage/SkuDocs/List'))
const ProdManageSkuDetail = lazy(
  () => import('./Product/Manage/SkuDocs/Detail')
)
const ProdDeliveryPlanList = lazy(
  () => import('./Product/Manage/DeliveryPlan/List')
)
const ProdDeliveryPlanDetail = lazy(
  () => import('./Product/Manage/DeliveryPlan/Detail')
)
const ProdShopGroupConfList = lazy(
  () => import('./Product/Manage/ShopGroupConf/List')
)
const ProdShopGroupGroupModal = lazy(() =>
  import('./Product/Manage/ShopGroupConf/List/ChildModal').then((module) => ({
    default: module.GroupModal,
  }))
)

const layoutRouter = [
  {
    path: '/',
    element: <Redirect to='/Task' />,
  },

  {
    path: '/home',
    element: <Redirect to='/Task' />,
  },
  {
    path: '/Task',
    element: <TaskList />,
  },
  {
    path: '/Supply/Orders/Purchase',
    element: <Purchase />,
  },
  {
    path: '/Supply/Base/Purchase',
    element: <BasePurchase />,
  },
  {
    path: '/Supply/Base/Warehouse',
    element: <BaseWarehouse />,
  },
  {
    path: '/Supply/Base/Mapping',
    element: <BaseMapping />,
  },
  {
    path: '/Supply/Base/ProductStatusList',
    element: <BaseProductStatus />,
  },
  {
    path: '/Supply/Base/ProductMappingList',
    element: <BaseProductMapping />,
  },
  {
    path: '/Supply/LogisticsCost/WarehouseBaseline',
    element: <WarehouseBaseline />,
  },
  {
    path: '/Supply/LogisticsCost/TransportBaseline',
    element: <TransportBaseline />,
  },
  {
    path: '/Supply/Orders/OrdersForecasting',
    element: <OrdersForecasting />,
  },
  {
    path: '/Supply/Orders/OrdersForecasting/Detail',
    element: <OrdersForecastingDetail />,
  },
  {
    path: '/Supply/productQuality/StandardsLibrary',
    element: <StandardsLibrary />,
  },
  {
    path: '/Supply/productQuality/StandardRuleConfiguration',
    element: <StandardRuleConfiguration />,
  },
  {
    path: '/Supply/productQuality/CheckOrder/List',
    element: <ProductQualityCheckOrderList />,
  },
  {
    path: '/Supply/productQuality/CheckOrder/Detail',
    element: <ProductQualityCheckOrderDetail />,
  },
  {
    path: '/Supply/SupplyCapacity',
    element: <SupplyCapacity />,
  },
  {
    path: '/Supply/SupplyCapacityDetail',
    element: <SupplyCapacityDetail />,
  },
  {
    path: '/Supply/CapacityManagementEdit',
    element: <SupplyCapacityManagementEdit />,
  },
  {
    path: '/Supply/SchedulingManagementEdit',
    element: <SupplySchedulingManagementEdit />,
  },
  {
    path: '/Supply/InventoryStatisticsEdit',
    element: <SupplyInventoryStatisticsEdit />,
  },
  {
    path: '/Supply/Orders/SupplyOrder',
    element: <SupplyOrder />,
  },
  {
    path: '/Supply/Orders/SupplyOrder/Add',
    element: <SupplyOrderAdd />,
  },
  {
    path: '/Supply/Orders/SupplyOrder/Detail',
    element: <SupplyOrderDetail />,
  },
  {
    path: '/Supply/Orders/SupplySend',
    element: <SupplySend />,
  },
  {
    path: '/Supply/Orders/SupplySend/Detail',
    element: <SupplySendDetail />,
  },
  {
    path: '/Supply/ProductLabelPrint',
    element: <ProductLabelPrintList />,
  },

  {
    path: '/Supply/Orders/Purchase/Detail',
    element: <PurchaseDetail />,
  },
  {
    path: '/Supply/Orders/Receipt',
    element: <Receipt />,
  },
  {
    path: '/Supply/Orders/Receipt/Detail',
    element: <ReceiptDetail />,
  },
  {
    path: '/Supply/Orders/Apply',
    element: <Apply />,
  },
  {
    path: '/Supply/Orders/Apply/Detail',
    element: <ApplyDetail />,
  },
  {
    path: '/Supply/CostManage/ProductSkuConversionCost',
    element: <ProductSkuConversionCost />,
  },
  {
    path: '/Supply/CostManage/WarehousingLogisticsCost',
    element: <WarehousingLogisticsCost />,
  },
  {
    path: '/StoreOpening/PartnerAdmittance',
    element: <PartnerAdmittance />,
  },
  {
    path: '/StoreOpening/PartnerAdmittance/Detail',
    element: <PartnerAdmittanceDetail />,
  },
  {
    path: '/Shareholder/Roll',
    element: <ShareholderRoll />,
  },
  {
    path: '/Shareholder/Roll/Detail',
    element: <ShareholderRollDetail />,
  },
  {
    path: '/Shareholder/Roll/Log',
    element: <ShareholderRollLog />,
  },
  {
    path: '/Shareholder/Share/Log',
    element: <ShareholderShareLog />,
  },
  {
    path: '/Shareholder/Profit/Log',
    element: <ShareholderProfitLog />,
  },
  {
    path: '/Shareholder/Share',
    element: <ShareholderShare />,
  },
  {
    path: '/Shareholder/Share/Detail',
    element: <ShareholderShareDetail />,
  },
  {
    path: '/Shareholder/User',
    element: <ShareholderUser />,
  },
  {
    path: '/FinFee/ShopProfitReport',
    element: <FinFeeShopProfitReport />,
  },
  {
    path: '/Shareholder/PrePare',
    element: <ShareholderPrePare />,
  },
  {
    path: '/Shareholder/Remit',
    element: <ShareholderRemit />,
  },
  {
    path: '/Shareholder/PrePare/Detail',
    element: <ShareholderPrePareDetail />,
  },
  {
    path: '/Shareholder/Profit',
    element: <ShareholderProfit />,
  },
  {
    path: '/Shareholder/SubjectBalance',
    element: <ShareholderSubjectBalance />,
  },
  {
    path: '/Shareholder/Profit/Detail',
    element: <ShareholderProfitDetail />,
  },
  {
    path: '/Shareholder/ShopTax',
    element: <ShopTax />,
  },

  {
    path: '/Setting/Account',
    element: <SettingAccount />,
  },
  {
    path: '/Setting/DeadMessage',
    element: <SettingDeadMessage />,
  },
  {
    path: '/Setting/DeadMessage/detail',
    element: <SettingDeadMessageDetail />,
  },
  {
    path: '/Setting/OrderStore',
    element: <SettingOrderStore />,
  },
  {
    path: '/Setting/OrderStoreV2',
    element: <SettingOrderStoreV2 />,
  },
  {
    path: '/personnelManagement',
    element: <PersonnelManagement />,
  },
  {
    path: '/personnelManagement/detail',
    element: <PersonnelManagementDetail />,
  },
  {
    path: 'workspace/waiting',
    label: '待办任务',
    element: '待办任务',
  },
  {
    path: 'workspace/finished',
    label: '已办任务',
    element: '已办任务',
  },
  {
    path: 'workspace/all',
    label: '已办任务',
    element: (
      <div>
        <p>已办任务</p>
      </div>
    ),
  },
  {
    path: 'Amortization/Base/TypeList',
    label: '摊销类型',
    element: <AmortizationBaseTypeList />,
  },
  {
    path: '/Amortization/manage/project/list',
    label: '摊销方案',
    element: <AmortizationManageList />,
  },
  {
    path: '/Amortization/manage/project/list/detail',
    label: '摊销方案详情',
    element: <AmortizationManageDetail />,
  },
  {
    path: '/Amortization/manage/check/list',
    label: '摊销检查',
    element: <CheckList />,
  },
  {
    path: '/Amortization/manage/change/list',
    label: '摊销变更',
    element: <AmortizationChangeList />,
  },
  {
    path: '/Amortization/manage/change/list/detail',
    label: '摊销方案变更详情',
    element: <AmortizationManageDetail />,
  },
  {
    path: '/Amortization/manage/stand/list',
    label: '摊销台账',
    element: <AmortizationStandBookList />,
  },
  {
    path: '/Amortization/manage/deal/list',
    label: '摊销处理',
    element: <AmortizationDealList />,
  },
  {
    path: '/Product/Menu/List',
    label: '菜单管理',
    element: <MenuList />,
  },
  {
    path: 'StoreOpening/TalentPlanning',
    label: '人才规划',
    element: <TalentPlanning />,
  },
  {
    path: 'StoreOpening/CityManage',
    label: '人才储备管理',
    element: <CityManage />,
  },
  // { // 需求变更暂时屏蔽
  //   path: 'StoreOpening/GridPlanning',
  //   label: '网络规划',
  //   element: <GridPlanningList />,
  // },
  {
    path: 'StoreOpening/NpDivision',
    label: '行政区基础信息库',
    element: <NpDivision />,
  },
  {
    path: 'StoreOpening/ProjectList',
    label: '项目列表',
    element: <ProjectList />,
  },
  {
    path: 'StoreOpening/NearestShop',
    label: '相邻门店列表',
    element: <NearestShop />,
  },
  {
    path: 'StoreOpening/ProjectList/Detail',
    element: <ProjectDetail />,
  },
  {
    path: 'StoreOpening/ProjectPreview',
    label: '项目列表',
    element: <ProjectPreviewList />,
  },
  {
    path: 'StoreOpening/ProjectManagementList',
    label: '项目信息',
    element: <ProjectManagementList />,
  },
  {
    path: 'StoreOpening/ProjectManagementDetail',
    label: '项目信息',
    element: <ProjectManagementDetail />,
  },
  {
    path: 'StoreOpening/PunchRecordList',
    label: '打卡记录',
    element: <PunchRecordList />,
  },
  {
    path: 'StoreOpening/ProjectPreview/Detail',
    element: <ProjectPreviewDetail />,
  },
  {
    path: 'StoreOpening/ProjectTalentMatch',
    label: '人才项目匹配',
    element: <ProjectTalentMatch />,
  },
  {
    path: 'StoreOpening/PartnershipArea/Map',
    label: '合伙人区域地图',
    element: <PartnershipAreaMap />,
  },
  {
    path: 'StoreOpening/PartnershipArea/Manage',
    label: '合伙人区域管理',
    element: <PartnershipAreaManage />,
  },
  {
    path: 'StoreOpening/Dev/Map',
    label: '合伙人区域地图',
    element: <DevMap />,
  },
  {
    path: 'StoreOpening/Dev/Manage',
    label: '合伙人区域管理',
    element: <DevManage />,
  },
  {
    path: 'Acceptance/Template',
    label: '验收模板',
    element: <Template />,
  },
  {
    path: 'Acceptance/TemplateConfig',
    label: '验收配置',
    element: <TemplateConfig />,
  },
  {
    path: '/MainReport/EC',
    element: <MainReportEC />,
  },
  {
    path: '/MainReport/EC/Detail',
    element: <MainReportECDetail />,
  },
  {
    path: '/Engine/OrderGroup',
    label: '财务账簿分组',
    element: <FinFeeOrderGroup />,
  },
  {
    path: '/Engine/Task',
    label: '财务账簿分组',
    element: <FinFeeTask />,
  },
  {
    path: '/Engine/SealList',
    label: '销售补单导入',
    element: <FinFeeSealList />,
  },

  {
    path: '/Engine/Log',
    label: '财务账簿生成记录',
    element: <FinFeeLog />,
  },
  {
    path: '/Engine/Source',
    label: '财务账簿生成记录',
    element: <FinFeeSource />,
  },
  {
    path: '/Engine/Tpl',
    label: '财务账簿生成记录',
    element: <FinFeeTpl />,
  },
  {
    path: '/FinFee/Budget/FreezeShop',
    label: '钱包冻结（新模式）',
    element: <FreezeShop />,
  },
  {
    path: '/FinFee/Budget/FreezeWater',
    label: '冻结流水',
    element: <FreezeWater />,
  },
  {
    path: '/FinFee/Budget/FeeApply',
    label: '结账检查',
    element: <FinFeeFeeApplyList />,
  },
  {
    path: '/FinFee/Budget/FeeApply/Detail',
    label: '结账检查',
    element: <FinFeeFeeApplyDetail />,
  },
  {
    path: '/FinFee/ClosingCheck',
    label: '结账检查',
    element: <ClosingCheck />,
  },
  {
    path: '/FinFee/Voucher',
    label: '手工凭证单',
    element: <FinFeeVoucher />,
  },
  {
    path: '/FinFee/Voucher/DetailList',
    label: '手工凭证单明细列表',
    element: <FinFeeVoucherDetailList />,
  },
  {
    path: '/FinFee/Voucher/MultiGroupList',
    label: '手工凭证单多借多贷凭证组列表',
    element: <FinFeeVoucherMultiGroupList />,
  },
  {
    path: '/FinFee/Voucher/MultiDetailList',
    label: '手工凭证单多借多贷明细列表',
    element: <FinFeeVoucherMultiDetailList />,
  },
  {
    path: '/FinFee/Report',
    label: '财务报销单列表',
    element: <FinFeeReport />,
  },
  {
    path: '/FinFee/Report/Detail',
    label: '财务报销单',
    element: <FinFeeReportDetail />,
  },
  {
    path: '/FinFee/FinFeeApproverRules',
    label: '审批人规则列表',
    element: <FinFeeApproverRules />,
  },
  {
    path: '/FinFee/FinFeeApproverRuleExpression',
    label: '审批人规则表达式列表',
    element: <FinFeeApproverRuleExpression />,
  },
  {
    path: '/FinFee/MemberCard/BeforeTransferList',
    label: '会员储值卡交易确认',
    element: <FinFeeMemberCardBeforeTransferList />,
  },
  {
    path: '/FinFee/MemberCard/TransferredList',
    label: '会员储值卡分账确认',
    element: <FinFeeMemberCardTransferredList />,
  },
  {
    path: '/FinFee/Budget/Category',
    label: '决算分类信息',
    element: <BudgetCategory />,
  },
  {
    path: '/FinFee/Budget/CategoryAfter',
    label: '决算分类信息',
    element: <BudgetCategoryAfter />,
  },
  {
    path: '/FinFee/Budget/Setting',
    label: '决算配置表',
    element: <BudgetSetting />,
  },
  {
    path: '/FinFee/Budget/PaymentMethodSetting',
    label: '付款方式配置表',
    element: <BudgetPaymentMethodSetting />,
  },
  {
    path: '/FinFee/Budget/ManualSettlementApply',
    label: '财务报销单',
    element: <BudgetManualSettlementApply />,
  },
  {
    path: '/FinFee/Budget/PaymentOrder',
    label: '财务报销单',
    element: <BudgetPaymentOrder />,
  },
  {
    path: '/FinFee/Budget/PaymentOrderDetails',
    label: '财务报销单',
    element: <NewBudgetPaymentOrderDetails />,
  },
  {
    path: '/FinFee/Budget/Order',
    label: '财务报销单',
    element: <BudgetOrder />,
  },
  {
    path: '/FinFee/Budget/InvestSettlement',
    label: '投资结算管理',
    element: <BudgetInvestSettlementList />,
  },
  {
    path: '/FinFee/Budget/InvestSettlement/Detail',
    label: '发起投资结算',
    element: <BudgetInvestSettlementDetail />,
  },
  {
    path: '/Engine/Tpl/Detail',
    label: '财务账簿生成记录',
    element: <FinFeeTplDetail />,
  },
  {
    path: '/FinFee/ManagementFee/ModeMaintenance',
    label: '管理费用模式维护',
    element: <FinFeeModeMaintenance />,
  },
  {
    path: '/FinFee/ManagementFee/ModeMaintenance/Detail',
    label: '管理费用模式详情',
    element: <FinFeeModeMaintenanceDetail />,
  },
  {
    path: '/FinFee/ManagementFee/ReportList',
    label: '管理费用报表',
    element: <FinFeeReportList />,
  },
  {
    path: '/FinFee/InvestProgress',
    label: '投资情况跟进',
    element: <FinInvestProgressList />,
  },
  {
    path: '/FinFee/SalesRecon/RuleSetting',
    label: '规则配置列表',
    element: <FinFeeSalesReconRuleSettingList />,
  },
  {
    path: '/FinFee/SalesRecon/RuleSetting/Detail',
    label: '规则配置详情',
    element: <FinFeeSalesReconRuleSettingDetail />,
  },
  {
    path: '/FinFee/SalesRecon/MallSalesDetail',
    label: '商场活动明细数据',
    element: <FinFeeSalesReconMallSalesDetail />,
  },
  {
    path: '/FinFee/SalesRecon/SalesReconDetails',
    label: '对账明细列表',
    element: <SalesReconDetailsList />,
  },
  {
    path: '/FinFee/SalesRecon/SalesReconDetails/CashDetail',
    label: '现金对账明细',
    element: <SalesReconDetailsCashDetail />,
  },
  {
    path: '/FinFee/SalesRecon/SalesReconDetails/OrderDetail',
    label: '销售对账明细',
    element: <SalesReconDetailsOrderDetail />,
  },
  {
    path: '/FinFee/Warning/List',
    label: '异常告警',
    element: <FinFeeWarningList />,
  },
  {
    path: '/FinFee/SalesRecon/SalesData',
    label: '销售对账单',
    element: <FinFeeSalesReconSalesDataList />,
  },
  {
    path: 'Flow/FlowList',
    label: '流程列表',
    element: <FlowList />,
  },
  {
    path: 'Flow/FlowDetail',
    label: '流程配置',
    element: <FlowDetail />,
  },
  {
    path: 'Flow/FlowImport',
    label: '流程同步',
    element: <FlowImport />,
  },
  {
    path: 'Flow/ServiceTaskList',
    label: '服务任务列表',
    element: <ServiceTaskList />,
  },
  {
    path: 'Flow/ServiceTaskList/Detail',
    label: '服务任务详情',
    element: <ServiceTaskDetail />,
  },
  {
    path: 'Flow/ApiList',
    label: '接口中心列表',
    element: <ApiList />,
  },
  {
    path: 'Flow/ApiList/Detail',
    label: '接口中心详情',
    element: <ApiDetail />,
  },
  {
    path: 'Flow/FlowFormData/List',
    label: '流程数据管理',
    element: <FlowFormList />,
  },
  {
    path: 'Flow/FlowFormData/List/Details',
    label: '流程数据管理',
    element: <FlowFormListDetails />,
  },
  {
    path: 'Contract/Rent/List',
    label: '租赁合同列表',
    element: <ContractRentList />,
  },
  {
    path: 'Contract/Rent/List/Detail',
    label: '租赁合同详情',
    element: <ContractRentDetail />,
  },
  {
    path: 'Contract/Project/Query',
    label: '工程合同查询',
    element: <ContractProjectList />,
  },
  {
    path: 'Contract/Project/Detail',
    label: '工程合同详情',
    element: <ContractProjectDetail />,
  },
  {
    path: 'Contract/Project/Config',
    label: '工程合同配置',
    element: <ContractProjectConfig />,
  },
  {
    path: 'Contract/Headquarters',
    label: '总部合同管理',
    element: <ContractHeadquartersList />,
  },
  {
    path: 'Contract/Headquarters/Detail',
    label: '总部合同详情',
    element: <ContractHeadquartersDetail />,
  },
  {
    path: 'activity/Meeting/List',
    label: '会议管理',
    element: <MeetingList />,
  },
  {
    path: 'activity/Meeting/List/Detail',
    label: '会议详情',
    element: <MeetingDetail />,
  },
  {
    path: 'activity/ManagerVoting/List',
    label: '投票列表',
    element: <VotingList />,
  },
  {
    path: 'activity/ManagerVoting/Detail',
    label: '投票详情',
    element: <VotingDetail />,
  },
  {
    path: 'activity/ManagerStudy',
    label: '店长大学堂',
    element: <ManagerStudyClassList />,
  },
  {
    path: 'activity/ManagerStudy/detail',
    label: '店长大学堂详情',
    element: <ManagerStudyClassDetail />,
  },
  {
    path: 'StoreContacts/List',
    label: '门店通讯录',
    element: <StoreContactsList />,
  },
  {
    path: 'Company/Bill/List',
    label: '公司列表',
    element: <CompanyBillList />,
  },
  {
    path: 'Company/Bill/List/Detail',
    label: '公司详情',
    element: <CompanyBillDetail />,
  },
  {
    path: 'Company/Seal/List',
    label: '印章列表',
    element: <CompanySealList />,
  },
  {
    path: 'Company/SealLog/List',
    label: '印章使用记录列表',
    element: <CompanySealLogList />,
  },
  {
    path: 'StoreTerminal/Store/List',
    label: '门店信息列表',
    element: <StoreTerminalList />,
  },
  {
    path: 'StoreTerminal/Store/Detail',
    label: '门店信息详情',
    element: <StoreTerminalDetail2 />,
  },
  {
    path: 'MasterDataLog/Manage/List',
    label: '主数据日志',
    element: <MasterDataLogList />,
  },
  {
    path: 'Spu/Manage/List',
    label: 'Spu列表',
    element: <SpuManageList />,
  },
  {
    path: '/FinFee/Fund/Balance',
    label: '扫呗余额',
    element: <FundBalance />,
  },
  {
    path: '/FinFee/Fund/RealTimeBalance',
    label: '扫呗实时余额',
    element: <FundRealTimeBalance />,
  },
  {
    path: '/FinFee/Fund/Account',
    label: '扫呗账号',
    element: <FundAccount />,
  },
  {
    path: '/FinFee/Fund/CIticBalance',
    label: '中信银行流水',
    element: <CIticBalance />,
  },
  {
    path: '/FinFee/Fund/DataBalance',
    label: '扫呗交易流水',
    element: <DataBalance />,
  },
  {
    path: '/FinFee/Fund/BankReconciliations',
    label: '民生银行银企对账',
    element: <BankReconciliations />,
  },
  {
    path: '/Store/WorkStartOrderTemplate/List',
    label: '开工令模板',
    element: <WorkStartOrderTemplateList />,
  },
  {
    path: '/Store/WorkStartOrderTemplate/Detail',
    label: '开工令模板详情',
    element: <WorkStartOrderTemplateDetail />,
  },
  {
    path: '/StoreOpening/BaseSettings/RevenueTemplate/List',
    label: '营业额模板列表',
    element: <RevenueTemplateList />,
  },
  {
    path: '/StoreOpening/BaseSettings/RevenueTemplate/Detail',
    label: '营业额模板详情',
    element: <RevenueTemplateDetail />,
  },
  {
    path: '/TaskManage/store',
    label: '门店任务管理',
    element: <StoreManage />,
  },
  {
    path: '/TaskManage/Plan',
    label: '门店计划管理',
    element: <StoreTaskPlanList />,
  },
  {
    path: '/TaskManage/TemplateList',
    label: '门店任务模板',
    element: <StoreTemplateList />,
  },
  {
    path: '/TaskManage/TemplateList/TemplateConfig',
    label: '门店任务模板配置',
    element: <StoreTemplateConfig />,
  },
  {
    path: '/StoreOperation/StoreTools',
    label: '门店小工具',
    element: <StoreTools />,
  },
  {
    path: '/StoreOpening/SmsNotify',
    label: '短信通知',
    element: <SmsNotifyList />,
  },
  {
    path: '/PeopleManage/ShopSalary',
    label: '门店工资单管理',
    element: <ShopSalaryList />,
  },
  {
    path: '/PeopleManage/ShopSalary/List',
    label: '门店工资单管理',
    element: <ShopSalaryList />,
  },
  {
    path: '/PeopleManage/ShopSalary/FieldConfig',
    label: '工资单字段管理',
    element: <ShopSalaryFieldConfig />,
  },
  {
    path: '/Product/Manage/SpuDocs',
    label: '商品主档 - SPU 管理列表',
    element: <ProdManageSpuList />,
  },
  {
    path: '/Product/Manage/SpuDocs/Detail',
    label: '商品主档 - SPU 详情',
    element: <ProdManageSpuDetail />,
  },
  {
    path: '/Product/Manage/SkuDocs',
    label: '商品主档 - SKU 管理列表',
    element: <ProdManageSkuList />,
  },
  {
    path: '/Product/Manage/SkuDocs/Detail',
    label: '商品主档 - SKU 详情',
    element: <ProdManageSkuDetail />,
  },
  {
    path: '/Product/Manage/DeliveryPlan',
    label: '商品主档 - 配送方案列表',
    element: <ProdDeliveryPlanList />,
  },
  {
    path: '/Product/Manage/DeliveryPlan/Detail',
    label: '商品主档 - 配送方案详情',
    element: <ProdDeliveryPlanDetail />,
  },
  {
    path: '/Product/Manage/ShopGroupConf',
    label: '商品主档 - 门店组列表',
    element: <ProdShopGroupConfList />,
    children: [
      {
        path: ':groupCode',
        label: '商品主档 - 门店组详情',
        element: <ProdShopGroupGroupModal />,
      },
    ],
  },
]

const withoutLayout = [
  {
    path: 'next',
    label: 'next',
    element: <Next />,
  },
]

export const defineRouter: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: layoutRouter,
  },
  ...withoutLayout,
  {
    path: '*',
    element: (
      <Layout>
        <ErrorPage />
      </Layout>
    ),
  },
]

const router = createBrowserRouter(defineRouter)

export default function RootRouterProvider() {
  const { isAuthed, fetched /* error */ } = useAuth(router.navigate)

  if (!isAuthed || !fetched) {
    // const hasError = fetched && error
    // const errMsg = hasError ? error || '未知错误' : undefined
    // splash page
    // return <SplashView errMsg={errMsg} />
    return null
  }

  return (
    <LazyComponent>
      <RouterProvider fallbackElement={<span>spinning</span>} router={router} />
    </LazyComponent>
  )
}
